import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import translationEn from 'app/locales/en/translation'
import translationFr from 'app/locales/fr/translation'

export const defaultNS = 'translation'
export const resources = {
    en: {
        translation: translationEn
    },
    fr: {
        translation: translationFr
    }
} as const
export type SupportedLanguage = keyof typeof resources
export const supportedLanguages = Object.keys(resources) as SupportedLanguage[]

export const EnglishLanguageKey: SupportedLanguage = 'en'
export const FrenchLanguageKey: SupportedLanguage = 'fr'

i18n.use(LanguageDetector)
    .use(HttpBackend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: false,
        fallbackLng: 'en',
        nonExplicitSupportedLngs: true,
        interpolation: { escapeValue: false },
        supportedLngs: supportedLanguages,
        defaultNS,
        resources,
        // Prevent language detection during SSR to avoid hydration mismatches
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        },
        // Configure react-i18next to avoid UNSAFE lifecycle methods
        react: {
            useSuspense: false,
            bindI18n: 'languageChanged loaded',
            bindI18nStore: 'added removed',
            transEmptyNodeValue: '',
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
        }
    })

export default i18n
